// Capability detection keeps browsers, Android, and older iOS builds on Leaflet.
export default class NativeMatchMap {
  static available() {
    return Boolean(window.webkit?.messageHandlers?.nativeMatchMap)
  }

  constructor(element, onFailure) {
    this.element = element
    this.onFailure = onFailure
    this.id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    this.active = true
    this.trackLayout = this.trackLayout.bind(this)
    this.frame = requestAnimationFrame(this.trackLayout)
    this.onPageHide = () => this.destroy()
    window.addEventListener("pagehide", this.onPageHide)
  }

  render(markers) {
    if (!this.active) return
    this.send({ action: "render", markers, layout: this.layout() })
  }

  layout() {
    const rect = this.element.getBoundingClientRect()
    const style = getComputedStyle(this.element)
    return {
      x: rect.left + window.scrollX,
      y: rect.top + window.scrollY,
      width: rect.width,
      height: rect.height,
      viewportWidth: document.documentElement.clientWidth,
      radius: parseFloat(style.borderRadius) || 0,
      visible: this.element.isConnected && rect.width > 0 && rect.height > 0 &&
        style.visibility !== "hidden" && !document.hidden
    }
  }

  trackLayout() {
    if (!this.active) return
    const layout = this.layout()
    const key = JSON.stringify(layout)
    if (key !== this.lastLayout) {
      this.lastLayout = key
      this.send({ action: "layout", layout })
    }
    if (this.active) this.frame = requestAnimationFrame(this.trackLayout)
  }

  send(payload) {
    try {
      Promise.resolve(window.webkit.messageHandlers.nativeMatchMap.postMessage({ id: this.id, ...payload }))
        .catch(() => this.fail())
    } catch {
      this.fail()
    }
  }

  fail() {
    if (!this.active) return
    this.destroy()
    this.onFailure()
  }

  destroy() {
    if (!this.active) return
    this.active = false
    window.removeEventListener("pagehide", this.onPageHide)
    cancelAnimationFrame(this.frame)
    try {
      Promise.resolve(window.webkit.messageHandlers.nativeMatchMap.postMessage({ action: "remove", id: this.id }))
        .catch(() => {})
    } catch { /* The web view may already be navigating away. */ }
  }
}
